import { render, staticRenderFns } from "./MinhaLoja.vue?vue&type=template&id=72a4ca18&scoped=true&"
import script from "./MinhaLoja.vue?vue&type=script&lang=js&"
export * from "./MinhaLoja.vue?vue&type=script&lang=js&"
import style0 from "./MinhaLoja.vue?vue&type=style&index=0&id=72a4ca18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4ca18",
  null
  
)

export default component.exports